import { styled } from '@mui/material';
import Dialog from '@mui/material/Dialog';

export const CurrencyDifferenceDialogStyledContainer = styled(Dialog)`
  .close-button {
    position: absolute;
    top: 8px;
    right: 8px;
  }
`;

export const CurrencyDifferenceStyledContainer = styled('section')`
  padding: 50px 30px 30px;
  gap: 15px;
  display: flex;
  flex-flow: column;
  width: 100%;
`;
